import canonicalRoutes from "./canonicalRoutes.json";
import pageGroups from "./pageTranslations.json";
import { MARKETING_LANGUAGES, MARKETING_LOCALES, MarketingLanguage } from "./marketingLocales";

type PageTranslations = Partial<Record<MarketingLanguage, string>>;
const groups = pageGroups as Record<string, PageTranslations>;
const homeTranslations = Object.fromEntries(MARKETING_LANGUAGES.map(language => [language, MARKETING_LOCALES[language].home])) as PageTranslations;
const groupByRoute = new Map<string, PageTranslations>();
for (const group of [homeTranslations, ...Object.values(groups)]) {
  for (const route of Object.values(group)) if (route) groupByRoute.set(route.toLowerCase(), group);
}

export function getCanonicalMarketingRoute(pathname: string): string {
  const normalizedRoute = pathname.replace(/\/+$/, "") || "/";
  return (canonicalRoutes as Record<string, string>)[normalizedRoute.toLowerCase()] ?? normalizedRoute;
}

export function getMarketingPageTranslations(pathname: string): PageTranslations {
  return groupByRoute.get(getCanonicalMarketingRoute(pathname).toLowerCase()) ?? {};
}

/** A destination language exists only for a known published marketing page. */
export function getMarketingPageLanguage(href: string): MarketingLanguage | undefined {
  if (!href.startsWith("/") || href.startsWith("//")) return undefined;
  const route = getCanonicalMarketingRoute(href.split(/[?#]/, 1)[0]);
  const translations = getMarketingPageTranslations(route);
  return MARKETING_LANGUAGES.find(language => translations[language]?.toLowerCase() === route.toLowerCase());
}

export function getLocalizedMarketingHref(href: string, language: MarketingLanguage): string {
  // Unknown app routes, external URLs, files and fragments are never rewritten.
  if (!href.startsWith("/") || href.startsWith("//")) return href;
  const separator = href.search(/[?#]/);
  const route = separator < 0 ? href : href.slice(0, separator);
  const suffix = separator < 0 ? "" : href.slice(separator);
  return (getMarketingPageTranslations(route)[language] ?? route) + suffix;
}
